<template>
	<div class="employee-card" v-if="employee" :class="{showing:display}">
		<img v-if="!employee.image_id" src="/images/blank_user_100.png"/>
		<img v-if="employee.image_id" class="uk-border-circle" :src="'/image/view/' + employee.image_id + '/100/100'"/>
		<div class="base-information">
			<div><a :href="'/employees/view/' + employee.id">{{ employee.full_name }}</a></div>
            <div>
                EID: {{ employee.id_number }}
            </div>
			<div v-if="employee.business_unit">
				BU: {{ employee.business_unit.name }}
			</div>
			<div v-if="employee.location">
				State: {{ employee.location.state }}
			</div>
			<div>
				Rating: {{ employee.average_rating }}
			</div>
			<div>
				Work Hours: {{ employee.total_hours }}
			</div>
		</div>
		<div class="uk-clearfix"></div>
		<div class="divider thin uk-margin-small"></div>
		<div class="uk-grid">
			<div class="uk-width-1-2" v-if="employee.crafts && employee.crafts.length > 0">
				<strong>Crafts</strong>
				<div v-for="craft in employee.crafts">{{ craft.name }}</div>
			</div>
			<div class="uk-width-1-2"
				 v-if="employee.person_certifications && employee.person_certifications.length > 0">
				<strong>Certifications</strong>
				<div v-for="certification in employee.person_certifications">{{ certification.certification.name }}
				</div>
			</div>
			<div class="uk-width-1-2" v-if="employee.person_trainings && employee.person_trainings.length > 0">
				<strong>Training</strong>
				<div v-for="training in employee.person_trainings">{{ training.training.name }}</div>
			</div>
			<div class="uk-width-1-2" v-if="employee.profile_notes && employee.profile_notes.length > 0">
				<strong>Manager Notes</strong>
				<div v-for="note in employee.profile_notes">{{ note.content }}</div>
			</div>
			<div class="uk-width-1-2" v-if="employee.raw_notes && employee.raw_notes.length > 0">
				<strong>Alerts</strong>
				<div v-for="note in employee.raw_notes">{{ note }}</div>
			</div>
			<div class="uk-width-1-2" v-if="employee.scheduleConflicts && employee.scheduleConflicts.length > 0">
				<strong>Scheduled Items</strong>
				<div v-for="conflict in employee.scheduleConflicts">{{ conflict.requisition.name }} {{ conflict.date ?
					"("+conflict.date.name+")":"" }}
				</div>
			</div>
            <div class="uk-width-1-2" v-if="employee.lastPlacement">
                <strong>Recent Job</strong>
                <div>{{employee.lastPlacement.name}}</div>
                <div>{{employee.lastPlacement.code}}</div>
            </div>
		</div>
		<i class="fas fa-times closer" @click="hide"></i>
	</div>
</template>

<script>
	export default {
		name: "EmployeeCard",

		components: {},

		props:{
			displayHours:{type:Boolean, default:false}
		},

		data() {
			return {
				employee: null,
				display: false,
				lastX:0,
				lastY:0,
			};
		},

		mounted() {
			document.addEventListener("mousemove", (ev) => this.follow(ev));
			this.placeBox(-500,-500);
		},

		methods: {
			show(emp) {
				if (emp) {
					this.display = true;
					this.employee = emp;
				}
				setTimeout(() => this.placeBox(this.lastX, this.lastY), 0);
			},

			hide() {
				this.display = false;
				setTimeout(() => this.placeBox(-500, -500), 340);
			},
			follow(event) {
				this.lastX = event.clientX;
				this.lastY = event.clientY;
			},
			placeBox(mouseX, mouseY){
				if (this.$el && this.$el.style) {
					if (mouseY > (window.innerHeight * .75)) {
						this.$el.style.top = "";
						this.$el.style.bottom = (window.innerHeight - mouseY) + "px";
					} else {
						this.$el.style.top = (mouseY - 120) + "px";
						this.$el.style.bottom = "";
					}

					if (mouseX > (window.innerWidth * .55)) {
						this.$el.style.left = "";
						this.$el.style.right = (window.innerWidth - mouseX + 50) + "px";
					} else {
						this.$el.style.left = (mouseX + 50) + "px";
						this.$el.style.right = "";
					}
				}
			}
		}
	}
</script>
